import React from 'react'
import "./BoxedContent.css"

function BoxedContent({
    heading="",
    para="",
    bgImg=""
}) {
  return (
    <div className='BoxedContent-container standard-padding-space'>
        <div className='container py-5'>
            <div className='row gy-lg-0 gy-4'>

            
            <div className='col-lg-8 '>
                <div className='px-4 h-100 '>
                    <div className='box p-4 h-100' >
                        <h3 className='body-heading'>{heading}</h3>
                        <p className='body-paragraph'>{para}</p>
                    </div>
                </div>
            </div>
            <div className='col-lg-4'>
                <div className='px-4 h-100'>
                    <div className='box p-4 mx-auto' style={{backgroundImage:`url(${bgImg})`,backgroundSize:"cover",backgroundRepeat:"no-repeat",backgroundColor:"white",height:"270px",width:"270px"}}></div>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default BoxedContent